import { Templates, Utils } from '@sparrow-marketing/contracts';
import { atom } from 'recoil';
import { ITemplateLeftNav, SubNav } from '../template-designer';
import { reportAdvanceLeftNav } from './constants';
import { IAdvancePlaceholder } from './types';

export const IsReportAdvanceState = atom<boolean>({
  key: 'is-report-advance-flow-state',
  default: false,
});

export const isAdvanceFlowLoaded = atom<boolean>({
  key: 'is-advance-flow-loaded',
  default: false,
});

export const ReportSideBarOptionState = atom<ITemplateLeftNav | null>({
  key: 'report-side-bar-option-state',
  default: reportAdvanceLeftNav,
});

export const ReportAdvanceActiveTabState = atom<{
  id: string;
  datasource: SubNav['type'];
  icon: string;
}>({
  key: 'report-advance-active-datasource',
  default: {
    id: '',
    datasource: '',
    icon: '',
  },
});

export const ReportAdvancePlaceholderState = atom<IAdvancePlaceholder>({
  key: 'report-advance-placeholder-state',
  default: {
    formattedPlaceholders: {},
    formattedVariables: {},
    groupSourceBySourceId: {},
    hints: {},
    rules: {},
  },
});

export const ReportDatasourceRulesState = atom<
  Utils.DynamicObject<string, boolean>
>({
  key: 'report-datasource-rules-state',
  default: {},
});

export const ReportDatasourceSkipState = atom<
  Utils.DynamicObject<
    string,
    Templates.GoogleDocProps.IRules['rules']['source']
  >
>({
  key: 'report-datasource-skip-state',
  default: {},
});

export const ReportDatasourceVariablesState = atom<
  Utils.DynamicObject<string, boolean>
>({
  key: 'report-datasource-variables-state',
  default: {},
});

export const ReportAdvanceDropdownState = atom<any>({
  key: 'report-dropdown-state',
  default: {},
});
